<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1024"
    @click:outside="dialog = false"
  >
    <template #activator="{ props }">
      <v-btn color="red-darken-3" variant="tonal" v-bind="props" class="ml-2"
        >Negar</v-btn
      >
    </template>

    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between">
          <span class="text-h5">Justificativa</span>
          <v-btn
            variant="plain"
            rounded="xl"
            prepend-icon="mdi-window-close"
            @click="dialog = false"
          ></v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="form" validate-on="lazy submit">
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="this.justificativa"
                  label="Justificativa*"
                  required
                  rows="4"
                  :rules="justificativaRules"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <small>*Campo obrigatório</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="blue-darken-1" variant="text" @click="submitForm">
          Salvar
          <v-progress-circular
            v-if="this.isLoading"
            class="ml-2"
            indeterminate
            size="20"
          />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/**
 * @module ModalNegarBug
 * @desc Modal para a criação da tarefa de correção do bug.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal
 * está visível.
 * @vue-data {string} [justificativa=''] - A justificativa para negar o bug.
 * @vue-data {string} idProjeto - O id do projeto.
 * @vue-data {boolean} [isLoading=false] - Loader da página.
 */
import axios from 'axios';

import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    id: Number,
  },
  emits: ['bugNegado'],
  data: () => ({
    dialog: false,
    justificativa: '',
    idProjeto: null,
    isLoading: false,
    justificativaRules: [(v) => !!v || 'Prioridade é obrigatória'],
  }),
  created() {
    this.idProjeto = this.$route.params.idProjeto;
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza requisição HTTP para criar a tarefa de implementação.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        this.isLoading = true;

        try {
          const result = await axios.put(
            `${apiUrl}/api/v1/bug/${this.id}`,
            {
              justificativa: this.justificativa,
              // eslint-disable-next-line camelcase
              status_bug: 'NEGADO',
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          this.$toast.success(result.data.msg);
          this.$emit('bugNegado');
          this.$router.push(`/projects/${this.idProjeto}/Bugs/${this.id}`);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.dialog = false;
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
